import { ButtonGroup, ButtonText, Checkbox, Col, Dialog, DialogCardBody, DialogCardFooter, DialogCardHead, DialogCardHeadTitle, Grid, Row } from "@visa/vds";
import { DateHelper } from "_helpers/DateHelper";
import MCSReadonlyField from "components/MCSReadonlyField";
import React, { useContext, useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { certificationPackageListService } from "services/certification.packageList";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import { PACKAGE_LIST_INTERNAL_MENU_ITEMS } from "_constants/CertificationTestingConstants";

const AdminReactivateOrDeactivateVstsAccess = ({ vstsAccessObj, fetchData, search, filters, pagination, open, setOpen,
    subscription, action, companyName, sorter }) => {

    const [deactivateOrReactivatelabel, setDeactivateOrReactivatelabel] = useState(action == PACKAGE_LIST_INTERNAL_MENU_ITEMS.DEACTIVATE_ACCESS ? "deactivate" : "reactivate")
    const [confirmReactivateOrDeactivate, setConfirmReactivateOrDeactivate] = useState(false)
    const alertContext = useContext(GlobalAlertContext);

    const handleWhenPageFirstLoads = () => {
        setDeactivateOrReactivatelabel(action == PACKAGE_LIST_INTERNAL_MENU_ITEMS.DEACTIVATE_ACCESS ? "deactivate" : "reactivate")
    }

    const deactivateOrReactivate = () => {
        const newVstsAccessObj = { ...vstsAccessObj, accessDeactivated: !vstsAccessObj.accessDeactivated }
        setConfirmReactivateOrDeactivate(false);

        trackPromise(
            certificationPackageListService.AdminReactivateOrDeactivateVstsAccess(newVstsAccessObj)
                .then(result => {
                    fetchData(pagination, filters, search, sorter)
                    setTimeout(function () {
                        var message = action == PACKAGE_LIST_INTERNAL_MENU_ITEMS.DEACTIVATE_ACCESS ? "VSTS Access deactivated successfully." : "VSTS Access reactivated successfully."
                        alertContext.setSuccessMessage(message);
                    }, 1500);
                }).catch(error => {
                    setTimeout(function () {
                        var message = action == PACKAGE_LIST_INTERNAL_MENU_ITEMS.DEACTIVATE_ACCESS ? "VSTS Access deactivated failed." : "VSTS Access reactivated failed."
                        alertContext.setErrorMessage(message)
                    }, 1500)
                    vstsAccessObj.accessDeactivated = !vstsAccessObj.accessDeactivated;
                })
        )
    }

    useEffect(() => {
        handleWhenPageFirstLoads()
    }, [subscription, action])

    return (
        <>
            <Dialog
                aria-describedby="deactivate-or-reactivate-vsts-access"
                onExit={() => { }}
                open={open}
                titleId="deactivate-or-reactivate-vsts-access"
            >
                <DialogCardHead>
                    {action && action === PACKAGE_LIST_INTERNAL_MENU_ITEMS.DEACTIVATE_ACCESS && <DialogCardHeadTitle id="dialog-title-manage-file">Confirm to deactivate VSTS Access for</DialogCardHeadTitle>}
                    {action && action === PACKAGE_LIST_INTERNAL_MENU_ITEMS.REACTIVATE_ACCESS && <DialogCardHeadTitle id="dialog-title-manage-file">Confirm to reactivate VSTS Access for</DialogCardHeadTitle>}
                </DialogCardHead>

                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Row>
                            <Col>
                                <MCSReadonlyField
                                    label="Business Name"
                                />
                            </Col>
                            <Col>{companyName}</Col>
                        </Row>
                        <Row>
                            <Col>
                                <MCSReadonlyField
                                    label="BID"
                                />
                            </Col>
                            <Col>{subscription && subscription.bid}</Col>
                        </Row>

                        <Row>
                            <Col>
                                <MCSReadonlyField
                                    label="VSTS Subscription Type"
                                />
                            </Col>
                            <Col>{subscription && subscription.subscriptionName.split(' ')[0]}</Col>
                        </Row>
                        <Row style={{ borderBottom: action === PACKAGE_LIST_INTERNAL_MENU_ITEMS.EXTEND_SUBSCRIPTION ? "1px solid grey" : null }}>
                            <Col>
                                <MCSReadonlyField
                                    label="Subscription Start Date"
                                />
                            </Col>
                            <Col>{subscription && DateHelper.ToFormattedDate(subscription.startDate)}</Col>
                        </Row>


                        <Row>
                            <Row>
                                <Col>
                                    <MCSReadonlyField
                                        label="Subscription End Date"
                                    />
                                </Col>
                                <Col>{subscription && DateHelper.ToFormattedDate(subscription.endDate)}</Col>
                            </Row>
                        </Row>
                        <Row style={{ marginLeft: "5px" }}>
                            <Checkbox
                                name="deactivate/reactivate-vsts-access"
                                label={`Confirm to ${deactivateOrReactivatelabel} VSTS Access`}
                                value={confirmReactivateOrDeactivate}
                                onChange={(e) => setConfirmReactivateOrDeactivate(!confirmReactivateOrDeactivate)}
                            />
                        </Row>
                    </Grid>
                </DialogCardBody>

                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => {
                                setOpen(null);
                                setConfirmReactivateOrDeactivate(false)
                            }}
                        >
                            Cancel
                        </ButtonText>
                        <ButtonText
                            colorScheme="primary"
                            onClick={() => {
                                setOpen(null);
                                deactivateOrReactivate();
                            }}
                            disabled={confirmReactivateOrDeactivate == false}
                        >
                            Save
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog >
        </>
    )
}

export default AdminReactivateOrDeactivateVstsAccess;